import React from 'react'
import i18n from 'i18next'
import MetaTags, { DEFAULT_META_TITLE, DEFAULT_SOCIAL_IMAGE, absoluteUrl, canonicalUrl } from '../utils/MetaTags'

/**
 * Record-level social preview tags for conversations, partners, topics and
 * journeys. Rendered deeper in the tree than the defaultMetaTags HOC, so
 * helmet's name/property dedupe makes these win over the site-level defaults.
 *
 * NOTE: metaTitle / metaDescription / metaImage come from the API, not from
 * this repo. Stale branding in a preview description is a data fix in ../web,
 * not a frontend one.
 */
const CustomMetaTags = ({ ...props }) => {
  const {
    record: { metaTitle, metaDescription, metaImage, hasMetaImage }
  } = props

  const title = metaTitle || DEFAULT_META_TITLE
  const description = metaDescription || i18n.t('meta.defaultDescription')
  const image = absoluteUrl(hasMetaImage && metaImage && metaImage.primary ? metaImage.primary.url : DEFAULT_SOCIAL_IMAGE)

  return (
    <MetaTags>
      <title>{title}</title>
      <meta name='description' content={description} />
      <meta property='og:title' content={title} />
      <meta property='og:description' content={description} />
      <meta property='og:image' content={image} />
      <meta property='og:url' content={canonicalUrl()} />
      <meta name='twitter:card' content='summary_large_image' />
    </MetaTags>
  )
}

export default CustomMetaTags
